import { useDirection } from '@radix-ui/react-direction'
import { X } from 'lucide-react'
import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import { acknowledgeLegalUpdateNotice, isLegalUpdateNoticeAcknowledged } from '@/lib/legalUpdateNotice'

export const LegalUpdateNotice: React.FC = () => {
  const { t } = useTranslation()
  const [showBanner, setShowBanner] = useState(false)
  const isRTL = useDirection() === 'rtl'

  useEffect(() => {
    if (!isLegalUpdateNoticeAcknowledged()) {
      setShowBanner(true)
    }
  }, [])

  const handleAcknowledge = useCallback(() => {
    acknowledgeLegalUpdateNotice()
    setShowBanner(false)
  }, [])

  if (!showBanner) {
    return null
  }

  return (
    <div className='fixed start-0 end-0 bottom-0 z-[60] border-t border-gray-200 bg-white p-4 shadow-lg md:p-6' dir={isRTL ? 'rtl' : 'ltr'}>
      <div className='relative container mx-auto max-w-6xl'>
        <Button
          onClick={handleAcknowledge}
          className='absolute end-0 -top-2 size-8'
          aria-label={t('common.close')}
          type='button'
          variant='ghost'
          size='icon'
        >
          <X className='h-5 w-5' />
        </Button>
        <div className='flex flex-col items-start gap-4 md:flex-row md:items-end'>
          <div className='flex-1'>
            <h3 className='mb-2 text-lg font-semibold'>{t('legalUpdateNotice.title')}</h3>
            <p className='mb-0 text-sm text-gray-700'>{t('legalUpdateNotice.body')}</p>
            <p className='mt-2 mb-0 text-xs text-gray-600'>
              <a href='https://shiptanbul.com/terms' className='text-blue-600 underline hover:text-blue-800'>
                {t('legalUpdateNotice.moreInfo')}
              </a>
            </p>
          </div>
          <div className='flex w-full md:w-auto'>
            <Button variant='default' size='sm' onClick={handleAcknowledge} className='whitespace-nowrap'>
              {t('legalUpdateNotice.confirm')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
